import { Button } from '@crm/ui';
import { MessageSquare, X } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  NOTIFICATIONS_ROUTES,
  useMarkNotificationRead,
  useNotifications,
  useNotificationsStream,
} from '../api';

/**
 * O aviso que fica na tela. Nao some sozinho de proposito: mensagem de
 * cliente que passa despercebida e cliente perdido - some quando alguem
 * decide o que fazer com ela.
 */
export function NotificationToasts() {
  useNotificationsStream();

  const navigate = useNavigate();
  const marcarLida = useMarkNotificationRead();
  const notificacoes = useNotifications({ unread: true, limit: 10 });

  const [dispensadas, setDispensadas] = useState<string[]>([]);

  const pendentes = (notificacoes.data?.data ?? []).filter(
    (item) => !dispensadas.includes(item.id),
  );

  if (pendentes.length === 0) return null;

  // Tres bastam: a partir do quarto, a pilha vira parede e some com a tela.
  const visiveis = pendentes.slice(0, 3);
  const restantes = pendentes.length - visiveis.length;

  return (
    // Rodape nos dois tamanhos; no celular a tela reserva o espaco dele (ver
    // o padding do main em app-layout), para o aviso nao cobrir conteudo.
    <div className="pointer-events-none fixed inset-x-4 bottom-4 z-50 flex flex-col gap-2 sm:inset-x-auto sm:right-4 sm:w-[22rem]">
      {visiveis.map((item) => (
        // Borda forte e sombra alta: o aviso pousa *sobre* a tela, e cartao
        // claro em fundo claro sumia dentro do conteudo.
        <div
          key={item.id}
          className="pointer-events-auto flex items-center gap-2 rounded-card border-2 border-primary/30 bg-card p-2.5 shadow-xl ring-1 ring-black/5"
        >
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
            <MessageSquare className="h-4 w-4" />
          </span>

          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium">{item.title}</p>
            <p className="truncate text-xs text-muted-foreground">{item.body}</p>
          </div>

          <Button
            size="sm"
            className="shrink-0"
            onClick={() => {
              marcarLida.mutate(item.id);
              if (item.link) navigate(item.link);
            }}
          >
            Abrir
          </Button>

          <button
            type="button"
            aria-label="Dispensar"
            className="shrink-0 text-muted-foreground hover:text-foreground"
            onClick={() => setDispensadas((atual) => [...atual, item.id])}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}

      {restantes > 0 ? (
        <button
          type="button"
          className="pointer-events-auto rounded-card border-2 border-primary/30 bg-card px-3 py-2 text-sm text-muted-foreground shadow-xl hover:bg-muted/60"
          onClick={() => navigate(NOTIFICATIONS_ROUTES.LIST)}
        >
          e mais {restantes} notificacoes
        </button>
      ) : null}
    </div>
  );
}
